module.exports = __webpack_public_path__ + "img/fisher-icon-close.89177332.svg";